import Box from '@mui/material/Box'
import config from 'config'
const Logo = () => {
  return <Box component="img" src={`${config.authUrl}/api/services/assets/stream/app/svgs/cube.svg`} sx={{ height: '28px' }} />
}

export default Logo
